const productData = [
  {
    id: 1,
    name: "Numajiri Camellia Patchwork Crew",
    price: "398.00",
    country: "Billy Reid",
    reviews: "124 Reviews",
    images: ["/img/101.webp", "/img/101a.webp"],
    size: ["S", "M", "L", "XL", "XXL"],
    description: [
      "Luxurious patchwork crew sweater featuring an intricate camellia pattern inspired by traditional Japanese textiles.",
      "Crafted from premium cotton blend with subtle texture variations across each panel.",
      "The Modern Southern aesthetic meets artisan craftsmanship in this statement piece.",
      "Perfect for layering during transitional seasons or wearing solo for a refined casual look.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Sweaters & Knits",
      "Material: Cotton Blend",
      "Fit: Standard Fit",
      "Made in USA",
      "Machine washable",
      "Ribbed collar, cuffs, and hem",
      "Unique patchwork design",
    ],
  },
  {
    id: 2,
    name: "Long Sleeve Numajiri Jacquard Shirt",
    price: "278.00",
    country: "Billy Reid",
    reviews: "89 Reviews",
    images: ["/img/102.webp", "/img/102a.webp"],
    size: ["S", "M", "L", "XL", "XXL", "LT", "XLT"],
    description: [
      "Sophisticated jacquard shirt showcasing an intricate geometric pattern woven directly into the fabric.",
      "The Numajiri pattern draws inspiration from traditional textile arts, reimagined for modern wear.",
      "Features premium mother-of-pearl buttons and refined collar construction.",
      "Versatile enough for both casual and smart-casual occasions.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Shirts",
      "Material: Cotton Jacquard",
      "Fit: Standard Fit",
      "Button-down collar",
      "Long sleeves with button cuffs",
      "Single chest pocket",
      "Jacquard woven pattern",
    ],
  },
  {
    id: 3,
    name: "Numajiri Box Jacquard Polo",
    price: "168.00",
    country: "Billy Reid",
    reviews: "156 Reviews",
    images: ["/img/103.webp", "/img/103a.webp"],
    size: ["S", "M", "L", "XL", "XXL"],
    description: [
      "Elevated polo shirt featuring a distinctive box jacquard pattern for added visual interest.",
      "Combines the comfort of a classic polo with sophisticated textile design.",
      "Perfect for golf outings, weekend brunches, or casual office environments.",
      "The textured fabric provides breathability while maintaining a polished appearance.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Polos",
      "Material: Cotton Blend",
      "Fit: Standard Fit",
      "Three-button placket",
      "Ribbed collar and cuffs",
      "Short sleeves",
      "Box jacquard texture",
    ],
  },
  {
    id: 4,
    name: "Felted Wool Chore Coat",
    price: "598.00",
    country: "Billy Reid",
    reviews: "93 Reviews",
    images: ["/img/104.webp", "/img/104a.webp"],
    size: ["S", "M", "L", "XL", "XXL", "LT", "XLT"],
    description: [
      "Heritage-inspired chore coat crafted from premium felted wool for exceptional warmth.",
      "Features classic workwear details reimagined with refined Southern sensibility.",
      "Multiple pockets provide functional storage while maintaining clean lines.",
      "The felted wool construction offers natural water resistance and wind protection.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Jackets & Outerwear",
      "Material: Wool Blend",
      "Fit: Relaxed Fit",
      "Four front pockets",
      "Button front closure",
      "Interior pockets",
      "Felted wool construction",
    ],
  },
  {
    id: 5,
    name: "Herringbone Bowery Coat",
    price: "748.00",
    country: "Billy Reid",
    reviews: "67 Reviews",
    images: ["/img/105.webp", "/img/105a.webp"],
    size: ["S", "M", "L", "XL", "XXL", "LT"],
    description: [
      "Sophisticated topcoat featuring a timeless herringbone pattern in premium wool.",
      "The Bowery silhouette offers a modern take on classic tailored outerwear.",
      "Full canvas construction ensures the coat drapes beautifully and ages gracefully.",
      "Perfect for layering over suits or elevating casual weekend looks.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Jackets & Outerwear",
      "Material: Wool",
      "Fit: Standard Fit",
      "Notch lapel",
      "Three-button front",
      "Herringbone pattern",
      "Full canvas construction",
    ],
  },
  {
    id: 6,
    name: "Flow Pickwick Shirt",
    price: "198.00",
    country: "Billy Reid",
    reviews: "142 Reviews",
    images: ["/img/106.webp", "/img/106a.webp"],
    size: ["S", "M", "L", "XL", "XXL", "LT", "XLT"],
    description: [
      "Lightweight button-down shirt with a relaxed, flowing silhouette for all-day comfort.",
      "Features breathable cotton construction perfect for warmer weather.",
      "The Pickwick design balances casual ease with refined details.",
      "Versatile styling pairs well with both denim and tailored trousers.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Shirts",
      "Material: Cotton",
      "Fit: Relaxed Fit",
      "Button-down collar",
      "Single chest pocket",
      "Long sleeves",
      "Breathable weave",
    ],
  },
  {
    id: 7,
    name: "Corduroy Cedar Shirt",
    price: "228.00",
    country: "Billy Reid",
    reviews: "118 Reviews",
    images: ["/img/107.webp", "/img/107a.webp"],
    size: ["S", "M", "L", "XL", "XXL", "LT", "XLT", "XXLT"],
    description: [
      "Classic corduroy shirt in a rich cedar tone that evokes autumn landscapes.",
      "Soft-hand corduroy provides warmth and texture without bulk.",
      "Perfect transition piece that works as both a shirt and light jacket.",
      "Modern Southern style with vintage workwear inspiration.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Shirts",
      "Material: Cotton Corduroy",
      "Fit: Standard Fit",
      "Button front closure",
      "Two chest pockets",
      "Long sleeves",
      "Soft corduroy texture",
    ],
  },
  {
    id: 8,
    name: "Wool Silk Flat Front Trouser",
    price: "298.00",
    country: "Billy Reid",
    reviews: "85 Reviews",
    images: ["/img/108.webp", "/img/108a.webp"],
    size: ["30", "31", "32", "33", "34", "35", "36", "38", "40"],
    description: [
      "Luxurious dress trousers blending wool and silk for exceptional drape and comfort.",
      "Flat front design provides a clean, modern silhouette.",
      "Perfect for the office, special occasions, or elevating weekend looks.",
      "The wool-silk blend offers natural wrinkle resistance and breathability.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Trousers",
      "Material: Wool Silk Blend",
      "Fit: Standard Fit",
      "Flat front",
      "Zip fly with button closure",
      "Side pockets",
      "Back welt pockets",
    ],
  },
  {
    id: 9,
    name: "Peony Jacquard Tuscumbia Shirt Button Down",
    price: "248.00",
    country: "Billy Reid",
    reviews: "134 Reviews",
    images: ["/img/109.webp", "/img/109a.webp"],
    size: ["S", "M", "L", "XL", "XXL", "LT", "XLT"],
    description: [
      "Distinctive button-down featuring an elegant peony jacquard pattern.",
      "The Tuscumbia silhouette offers Billy Reid's signature comfortable fit.",
      "Artistic floral pattern adds visual interest while remaining sophisticated.",
      "Versatile enough for both casual and semi-formal occasions.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Shirts",
      "Material: Cotton Jacquard",
      "Fit: Standard Fit",
      "Button-down collar",
      "Jacquard woven pattern",
      "Long sleeves",
      "Single chest pocket",
    ],
  },
  {
    id: 10,
    name: "Large Scale Plaid Western Shirt",
    price: "218.00",
    country: "Billy Reid",
    reviews: "97 Reviews",
    images: ["/img/1010.webp", "/img/1010a.webp"],
    size: ["S", "M", "L", "XL", "XXL", "LT", "XLT", "XXLT"],
    description: [
      "Bold western shirt featuring an oversized plaid pattern for maximum impact.",
      "Classic snap-button front with pointed yoke details.",
      "Modern Southern interpretation of traditional western wear.",
      "Comfortable cotton construction perfect for year-round wear.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Shirts",
      "Material: Cotton",
      "Fit: Standard Fit",
      "Snap-button front",
      "Western yoke",
      "Two chest pockets with snaps",
      "Large scale plaid pattern",
    ],
  },
  {
    id: 11,
    name: "Peacoat Cape",
    price: "898.00",
    country: "Billy Reid",
    reviews: "52 Reviews",
    images: ["/img/1011.webp", "/img/1011a.webp"],
    size: ["S", "M", "L", "XL", "XXL"],
    description: [
      "Innovative peacoat design featuring a dramatic cape overlay.",
      "Combines naval heritage with contemporary fashion-forward styling.",
      "Premium wool construction provides exceptional warmth and structure.",
      "Statement piece that elevates any cold-weather wardrobe.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Jackets & Outerwear",
      "Material: Wool",
      "Fit: Standard Fit",
      "Cape overlay detail",
      "Double-breasted front",
      "Interior pockets",
      "Anchor buttons",
    ],
  },
  {
    id: 12,
    name: "Washed Leather Blazer",
    price: "1,298.00",
    country: "Billy Reid",
    reviews: "43 Reviews",
    images: ["/img/1012.webp", "/img/1012a.webp"],
    size: ["S", "M", "L", "XL", "XXL"],
    description: [
      "Luxurious leather blazer with a soft, washed finish for lived-in character.",
      "Tailored construction maintains structure while leather provides unique texture.",
      "Perfect balance between rugged and refined for versatile styling.",
      "Investment piece that develops rich patina over time.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Jackets & Outerwear",
      "Material: Washed Leather",
      "Fit: Standard Fit",
      "Two-button front",
      "Notch lapel",
      "Interior and exterior pockets",
      "Fully lined",
    ],
  },
  {
    id: 13,
    name: "Herringbone Deck Coat",
    price: "698.00",
    country: "Billy Reid",
    reviews: "76 Reviews",
    images: ["/img/1013.webp", "/img/1013a.webp"],
    size: ["S", "M", "L", "XL", "XXL", "LT", "XLT"],
    description: [
      "Nautical-inspired deck coat in classic herringbone wool.",
      "Features functional details designed for seafaring life adapted for modern wear.",
      "Generous pockets and durable construction for everyday utility.",
      "Timeless pattern and silhouette ensure years of stylish wear.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Jackets & Outerwear",
      "Material: Wool Herringbone",
      "Fit: Relaxed Fit",
      "Button front closure",
      "Multiple pockets",
      "Interior storm shield",
      "Herringbone weave",
    ],
  },
  {
    id: 14,
    name: "Belted Leather Coat",
    price: "1,498.00",
    country: "Billy Reid",
    reviews: "38 Reviews",
    images: ["/img/1014.webp", "/img/1014a.webp"],
    size: ["S", "M", "L", "XL", "XXL"],
    description: [
      "Sophisticated leather topcoat featuring a self-belt for adjustable silhouette.",
      "Premium leather construction ensures durability and timeless appeal.",
      "The belted design allows for personalized fit and styling options.",
      "Modern Southern luxury for the discerning wardrobe.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Jackets & Outerwear",
      "Material: Leather",
      "Fit: Standard Fit",
      "Self-belt with buckle",
      "Button front closure",
      "Notch collar",
      "Fully lined interior",
    ],
  },
  {
    id: 15,
    name: "Feather Jacquard Top Coat",
    price: "848.00",
    country: "Billy Reid",
    reviews: "61 Reviews",
    images: ["/img/1015.webp", "/img/1015a.webp"],
    size: ["S", "M", "L", "XL", "XXL", "LT", "XLT"],
    description: [
      "Elegant topcoat featuring a subtle feather jacquard pattern woven into the fabric.",
      "The sophisticated texture adds depth while maintaining formal versatility.",
      "Perfect for business wear or special occasions requiring refined outerwear.",
      "Traditional tailoring meets artistic textile design.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Jackets & Outerwear",
      "Material: Wool Jacquard",
      "Fit: Standard Fit",
      "Three-button front",
      "Feather jacquard pattern",
      "Notch lapel",
      "Interior pockets",
    ],
  },
  {
    id: 16,
    name: "New Folk Jacquard Cardigan Coat",
    price: "578.00",
    country: "Billy Reid",
    reviews: "94 Reviews",
    images: ["/img/1016.webp", "/img/1016a.webp"],
    size: ["S", "M", "L", "XL", "XXL", "LT"],
    description: [
      "Cozy cardigan coat featuring folk-inspired jacquard patterns.",
      "Combines the comfort of knitwear with the structure of a coat.",
      "Perfect layering piece for transitional weather and relaxed occasions.",
      "Artistic pattern celebrates traditional craft in a modern silhouette.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Sweaters & Knits",
      "Material: Wool Blend Jacquard",
      "Fit: Relaxed Fit",
      "Button front closure",
      "Shawl collar",
      "Two front pockets",
      "Folk pattern jacquard",
    ],
  },
  {
    id: 17,
    name: "Shoals Denim Shirt",
    price: "198.00",
    country: "Billy Reid",
    reviews: "187 Reviews",
    images: ["/img/1017.webp", "/img/1017a.webp"],
    size: ["S", "M", "L", "XL", "XXL", "LT", "XLT", "XXLT"],
    description: [
      "Classic denim shirt crafted from premium Japanese selvedge denim.",
      "The Shoals fit offers comfortable room through the body without excess fabric.",
      "Versatile wardrobe staple that pairs with everything from chinos to jeans.",
      "Durable construction ensures this shirt will only get better with age.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Shirts",
      "Material: Denim",
      "Fit: Standard Fit",
      "Button front closure",
      "Two chest pockets",
      "Long sleeves",
      "Selvedge denim construction",
    ],
  },
  {
    id: 18,
    name: "MSL 1-Pocket Shirt",
    price: "168.00",
    country: "Billy Reid",
    reviews: "203 Reviews",
    images: ["/img/1018.webp", "/img/1018a.webp"],
    size: ["S", "M", "L", "XL", "XXL", "LT", "XLT"],
    description: [
      "Modern Southern Living collaboration shirt with minimalist single-pocket design.",
      "Clean lines and quality construction define this essential wardrobe piece.",
      "Lightweight fabric perfect for year-round wear in the South.",
      "Effortless style that transitions seamlessly from casual to smart-casual.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Shirts",
      "Material: Cotton",
      "Fit: Standard Fit",
      "Button-down collar",
      "Single chest pocket",
      "Long sleeves",
      "MSL collaboration",
    ],
  },
  {
    id: 19,
    name: "Long Sleeve Pensacola Polo",
    price: "128.00",
    country: "Billy Reid",
    reviews: "165 Reviews",
    images: ["/img/1019.webp", "/img/1019a.webp"],
    size: ["S", "M", "L", "XL", "XXL", "LT", "XLT"],
    description: [
      "Versatile long sleeve polo perfect for cooler weather or air-conditioned spaces.",
      "The Pensacola style combines athletic comfort with refined appearance.",
      "Premium pique cotton provides breathability and texture.",
      "Ideal for golf, casual office wear, or weekend activities.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Polos",
      "Material: Cotton Pique",
      "Fit: Standard Fit",
      "Three-button placket",
      "Ribbed collar and cuffs",
      "Long sleeves",
      "Side vents",
    ],
  },
  {
    id: 20,
    name: "Arnie Oxford Shirt",
    price: "178.00",
    country: "Billy Reid",
    reviews: "176 Reviews",
    images: ["/img/1020.jpg", "/img/1020a.jpg"],
    size: ["S", "M", "L", "XL", "XXL", "LT", "XLT", "XXLT"],
    description: [
      "Timeless oxford cloth button-down shirt in Billy Reid's signature Arnie fit.",
      "Premium oxford weave provides durability and classic texture.",
      "The perfect foundation piece for both casual and business-casual wardrobes.",
      "Garment-washed for immediate softness and lived-in comfort.",
    ],
    Features: [
      "Brand: Billy Reid",
      "Category: Shirts",
      "Material: Cotton Oxford",
      "Fit: Standard Fit",
      "Button-down collar",
      "Single chest pocket",
      "Long sleeves with button cuffs",
      "Garment-washed finish",
    ],
  },
];

export default productData;
